import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgTicketFiltersClose = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" {...props}>
    <g fill="#17181A" fillRule="evenodd">
      <path d="m12.157.136.707.707L.844 12.864l-.708-.707z" />
      <path d="m12.864 12.157-.707.707L.136.844.843.135z" />
    </g>
  </svg>
);
const Memo = memo(SvgTicketFiltersClose);
export default Memo;
